import { Timestamp } from 'firebase/firestore'
import { Dispatch, SetStateAction } from 'react'
import { Org } from './OrganizationInterface'
import { UserAddress } from './AddressInterface'
import { User } from './UserInterface'

export interface Donation {
  id: string
  amount: number
  anonymous?: boolean
  checkCashed?: boolean
  checkSent?: boolean
  contacted?: boolean
  coverFees?: boolean
  corporateMatch?: string
  corporateStatus?: number
  cot?: boolean
  customLink?: string
  date: Timestamp | Date | {
    seconds: number
    nanoseconds: number
  }
  donationAmount?: number
  email?: string
  fee?: number
  fundraiserUserId?: string
  img?: string
  match?: number
  matchPercentage?: number
  name?: string
  org: Org
  organization?: { name?: string; [key: string]: unknown }
  orgId: string
  paymentId: string
  paymentIntent?: string
  payoutAmount?: number
  period?: string
  recurring: boolean
  source?: string
  frequency?: string
  stripeConnectCustomerId?: string
  stripeCustomerId: string | null
  subscriptionId?: string
  type?: string
  user?: UserAddress
  userId: string
  role?: string
}

export interface BusinessDonation extends Omit<Donation, 'user'> {
  user?: User
  total?: number
  status?: number
  orgName?: string
  name?: string
  matchAmount?: number
}

export interface RecurringDonation {
  id: string
  orgId: string
  active: boolean
  startDate: Timestamp | Date | string
  [key: string]: unknown
}

export interface GetSelectedUserDonationsParams {
  userId: string
  donations?: Donation[]
  rowsPerPage: number
  currentPage: number
  donationsCount: number
  nextPage: number
}

export interface DonationHistoryResult {
  donationsCount: number
  donations: Array<{
    id: string
    source?: string
    frequency?: string
    amount?: number
    date?: string
    [key: string]: unknown
  }>
  totalDonation?: number
  nextPage: number
}

export interface DonationWithChampion extends Donation {
  champion?: User
}

// Context Props
export interface DonationsContextProps {
  recentDonations: Donation[]
  setGetDonations: Dispatch<SetStateAction<boolean>>
  ourDonations: Donation[]
  setOurDonations: Dispatch<SetStateAction<Donation[]>>
  ourRecurringDonations: RecurringDonation[]
  selectedDonation: Donation | null
  setSelectedDonation: Dispatch<SetStateAction<Donation | null>>
  // Future fields (not currently used in context but may be needed)
  search?: string
  setSearch?: Dispatch<SetStateAction<string>>
  filtered?: Donation[] | []
  setFiltered?: Dispatch<SetStateAction<Donation[] | []>>
  rowsPerPage?: number
  setRowsPerPage?: Dispatch<SetStateAction<number>>
  currentPage?: number
  setCurrentPage?: Dispatch<SetStateAction<number>>
}

export const DonationsContextDefaultValues: DonationsContextProps = {
  recentDonations: [],
  setGetDonations: () => {},
  ourDonations: [],
  setOurDonations: () => {},
  ourRecurringDonations: [],
  selectedDonation: null,
  setSelectedDonation: () => {},
}
